import React from 'react';
import { Label } from 'semantic-ui-react'; // Import LabelProps
import ProfessorTitle from '../../common/titles/ProfessorTitle';
import { Professor } from '../../interfaces/professor';
import CourseTitle from '../../common/titles/CourseTitle';
import { Course } from '../../interfaces/course';

type SearchResultType = 'Professor' | 'Course';

const COLORS_MAP: Record<SearchResultType, string> = {
    Professor: '#FFC800',
    Course: '#92B6E6',
};

type SearchRowProps =
    | { label: 'Professor'; content: Professor }
    | { label: 'Course'; content: Course };

/**
 * Displays a single row in a search results list, linking to either a
 * professor or a course page.
 */
const SearchRow: React.FC<SearchRowProps> = (props) => {
    const { label, content } = props;

    let path: string;
    let text: React.ReactNode;

    if (label === 'Professor') {
        path = `/professor/${content.professor_id}`;
        text = <ProfessorTitle professor={content} includeBadge={true} />;
    } else if (label === 'Course') {
        path = `/course/${content.course_id}`;
        text = <CourseTitle course={content} />;
    } else {
        console.error(`Unexpected search row label: ${label}`);
        return null;
    }

    const labelStyle: React.CSSProperties = {
        backgroundColor: COLORS_MAP[label], // Accessing COLORS_MAP is type-safe
    };

    return (
        <a href={path}>
            <div className="flex-space-between items-center">
                <div className="items-center">{text}</div>
                <Label style={labelStyle} content={label} />
            </div>
        </a>
    );
};

export default SearchRow;
